<template>
  <div class="video">
    <div class="Lunbo">
      <van-swipe
        class="my-swipe"
        :show-indicators="false"
        :loop="true"
        @change="handleSwipeChange"
        :initial-swipe="currentVideoIndex"
      >
        <van-swipe-item v-for="(video, index) in videos" :key="index">
          <video
            ref="videoPlayers"
            :src="video.src"
            preload="auto"
            @ended="playNext"
            autoplay
          ></video>
          <div class="v_p">
            <div class="p_box">
              <div class="p_wrap">
                <h2 class="p_t">{{ $t("system.home.p_t") }}</h2>
                <div class="w_z" @click="watchFullVideo">
                  <div class="w_z_t">{{ $t("system.home.w_z_t") }}</div>
                  <div class="z_lo"></div>
                </div>
              </div>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted,computed } from "vue";
import { useI18n } from "vue-i18n";
const { locale } = useI18n();
const videos = ref([
  {
    src: locale.value === 'zh-cn' 
      ? 'https://open-scrm-9tpvedvdif44.oss-cn-shanghai.aliyuncs.com/xiaolong_gw/video/ch.mp4'
      : 'https://open-scrm-9tpvedvdif44.oss-cn-shanghai.aliyuncs.com/xiaolong_gw/video/en.mp4',
    isPlaying: false,
  },
]);

const videoPlayers = ref<HTMLVideoElement[]>([]);
const currentVideoIndex = ref(0);

onMounted(() => {
  const videoElements = document.querySelectorAll("video");
  videoPlayers.value = Array.from(videoElements) as HTMLVideoElement[];

  if (videoPlayers.value.length > 0) {
    videoPlayers.value.forEach(video => {
      video.muted = true;
      // 移除自动播放属性
      video.removeAttribute('autoplay');
      // 添加播放控制
      video.addEventListener('play', () => {
        video.muted = true;
      });
    });

    // 只初始化第一个视频
    const firstVideo = videoPlayers.value[0];
    firstVideo.muted = true;
    firstVideo.play().catch((error) => {
      console.error("初始视频播放失败:", error);
    });

    // 为所有视频添加加载错误处理
    videoPlayers.value.forEach((video) => {
      video.addEventListener("error", (e) => {
        console.error("视频加载错误:", e);
      });
    });
  }
});
onUnmounted(() => {
  videoPlayers.value.forEach((video) => {
    video.pause();
    video.remove();
  });
});
function playNext() {
  const nextIndex = (currentVideoIndex.value + 1) % videos.value.length;
  handleSwipeChange(nextIndex);
}
const handleSwipeChange = (index: number) => {
  currentVideoIndex.value = index;
  // 停止所有视频
  videoPlayers.value.forEach((video, idx) => {
    if (idx !== index) {
      video.pause();
      video.currentTime = 0;
    }
  });

  // 播放当前视频
  const currentVideo = videoPlayers.value[index];
  if (currentVideo) {
    currentVideo.muted = true;
    currentVideo.currentTime = 0;
    currentVideo.play().catch((error) => {
      console.error("视频播放失败:", error);
    });
  }
};
function watchFullVideo() {
  const video = document.createElement("video");
  // video.src = fullVideoUrl;
  // video.src =
  //   "https://open-scrm-9tpvedvdif44.oss-cn-shanghai.aliyuncs.com/xiaolong_gw/%E9%A6%96%E9%A1%B5%E8%A7%86%E9%A2%91/video.mp4";
  // 使用当前正在播放的视频源
  video.src = videos.value[currentVideoIndex.value].src;
  video.autoplay = true; // 改为自动播放
  video.muted = false; // 取消静音
  document.body.appendChild(video);

  // 请求全屏播放
  if (video.requestFullscreen) {
    video.requestFullscreen();
  } else if (video.webkitRequestFullscreen) {
    /* Safari */
    video.webkitRequestFullscreen();
  } else if (video.mozRequestFullScreen) {
    /* Firefox */
    video.mozRequestFullScreen();
  } else if (video.msRequestFullscreen) {
    /* IE/Edge */
    video.msRequestFullscreen();
  }

  // 监听全屏变化事件
  document.addEventListener("fullscreenchange", exitHandler);
  document.addEventListener("webkitfullscreenchange", exitHandler);
  document.addEventListener("mozfullscreenchange", exitHandler);
  document.addEventListener("MSFullscreenChange", exitHandler);

  // 全屏退出处理函数
  function exitHandler() {
    if (
      !document.fullscreenElement &&
      !document.webkitFullscreenElement &&
      !document.mozFullScreenElement &&
      !document.msFullscreenElement
    ) {
      video.pause();
      document.body.removeChild(video);
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.video {
  width: 100%;
  // height: calc(100vh - 120px);  // 设置视频区域高度
  height: auto;
}
.Lunbo {
  margin-top: 120px;  // 改用margin-top替代padding
  position: relative;
  width: 100%;
  height: 100%;  // 设置为100%高度
}
.my-swipe {
  height: 100%;  // 添加高度100%
}
.bei_j {
  position: absolute;
  left: 0;
  bottom: 92px;
  width: 676px;
  height: 27px;
}
.warp {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  height: 93px;
  background-color: rgb(31, 83, 104);
  color: #ffffff;
}
.v_p {
  position: absolute;
  top: 50%;
  left: 0%;
  transform: translate(0, -100%);
  z-index: 1;
  width: 100%;
  height: 100px;
  color: #ffffff;
}
.p_box {
  width: 100%;
  margin: 0 auto;
  padding: 0 15px;
  max-width: 1230px;
}
.p_wrap {
  position: relative;
  max-width: 74%;
  margin: 0 auto;
}
.p_t {
  font-size: 50px;
  line-height: 1.1;
  max-height: 160px;
  overflow: hidden;
  font-weight: bold;
  text-shadow: 2px 2px 4px rgba(49, 52, 53, 0.47);
}
.w_z {
  display: inline-flex;
  flex-wrap: nowrap;
  font-size: 14px;
  line-height: 30px;
  font-weight: 500;
  max-width: 200px;
  background-color: #004080;
  width: auto;
  align-items: center;
  color: #ffffff;
  min-width: 120px;
  border-radius: 8px;
  cursor: pointer;
  padding: 0px 10px;
  margin-top: 20px;
}
h2 {
  margin: 0;
}
.w_z div {
  color: #fff;
}
.z_lo {
  width: 0;
  height: 0;
  margin-left: 15px;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
  border-left: 10px solid #ffffff;
}
.my-swipe .van-swipe-item {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  cursor: default;
  height: calc(100vh - 50px);  // 设置视频区域高度
}
/* 视频宽度铺满轮播项 */
.my-swipe .van-swipe-item video {
  height: 100%;
  width: 100%;
  object-fit: fill; // 改用contain确保视频完整显示
}
.w_inner {
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 0 15px;
}
.inner_left {
  width: auto;
  height: 93px;
}
.inner_left .img_o {
  width: 255px;
  height: 35px;
}
.inner_left .text {
  width: auto;
  height: 28px;
  overflow: hidden;
  font-size: 20px;
  line-height: 28px;
  margin-top: 10px;
}
.inner_right {
  display: flex;
  align-items: center;
}
.search-input {
  border: 1px solid #ccc;
  color: #000;
  padding: 0 10px;
  height: 40px;
  border-radius: 5px;
  width: 745px;
  margin-right: 22px;
}
.search-button {
  position: relative;
  padding: 10px;
  width: 60px;
  height: 30px;
  border: 2px #fff solid;
  background-color: #1f5368;
  border-radius: 10px;
  color: #fff;
  cursor: pointer;
}
.i {
  position: absolute;
  left: 18px;
  bottom: 0;
  font-size: 24px;
}
.w_z:hover {
  border: #1f5368 1px solid;
  background-color: #fff;
  div {
    color: #1f5368;
  }
  .z_lo {
    border-left: 10px solid #1f5368;
  }
}
.my-swipe .van-swipe-item video::-webkit-media-controls {
  display: none !important;
}
.my-swipe .van-swipe-item video::-webkit-media-controls-panel {
  display: none !important;
}
</style>
